// Helper to convert snake_case to camelCase
const snakeToCamel = str => {
    return str.toLowerCase()
        .replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
        .replace(/_(\d)/g, (_, digit) => digit)
}

export { snakeToCamel };